import { useEffect, useRef } from 'react';

import { LS_IS_JUST_SIGNED_IN_NAME, LS_IS_JUST_SIGNED_IN_VALUE } from '@/entities/user/currentUser';

import { API } from '@/shared/api';
import { GTMEvents } from '@/shared/thirdParty/gtm';
import { User } from '@/shared/types/User';

export const useGTMAuthorization = (user?: User) => {
  const lastUserIdRef = useRef<User['id']>();

  useEffect(() => {
    if (user?.id && lastUserIdRef.current !== user.id) {
      GTMEvents.setUserId(user.id);
      void GTMEvents.identifyUser(user);
      lastUserIdRef.current = user.id;

      if (localStorage.getItem(LS_IS_JUST_SIGNED_IN_NAME) === LS_IS_JUST_SIGNED_IN_VALUE) {
        localStorage.removeItem(LS_IS_JUST_SIGNED_IN_NAME);
        GTMEvents.login();

        try {
          void API.sendUserLoginEvent();
        } catch {
          // do nothing
        }
      }
    }
  }, [user]);
};
